export * from './debounce';
export * from './errorHandler';
export * from './placeholder';
export * from './font-size';
export * from './tabFormatter';

// Utility function to capitalize first letter of each word
export const capitalizeWords = (str) => {
  if (!str || typeof str !== 'string') return str;
  return str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const openLinkInNewTab = link => {
  var anchorTag = document.createElement('a');
  // anchorTag.setAttribute('target', '_blank');
  // anchorTag.setAttribute('rel', 'noopener noreferrer');
  anchorTag.setAttribute('href', link);
  anchorTag.setAttribute('style', 'display:none;');
  document.body.appendChild(anchorTag);
  anchorTag.click();
};
